import React from 'react'
import Product from './Product'

export default function ProductsList() {
  return (
    <div>
      <Product />
      <Product />
    </div>
  )
}
